<aside class="page-aside" style="max-height:calc(100vh - var(--wa-spacing-3x-large));min-width:14rem;overflow-y:auto;padding:0 var(--wa-spacing-large) var(--wa-spacing-large) var(--wa-spacing-large);position:sticky;top:var(--wa-spacing-large);">
	<wa-input (wa-clear)="onFilterChange($event)" (wa-input)="onFilterChange($event)" clearable placeholder="Filter plugins…" size="small" style="margin-bottom:var(--wa-spacing-medium);">
		<wa-icon name="magnifying-glass" slot="start"></wa-icon>
	</wa-input>
	<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>Plugins & Categories</div>
	<wa-tree style="--indent-guide-color:var(--wa-color-neutral-300);--indent-size:12px;">
		<wa-tree-item>
			<span style="font-weight:var(--wa-font-weight-semibold);">Rendering & UI</span>
			<wa-tree-item>
				<a (click)="navigateToPlugin('core')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JWebMP Core</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('core', 'page')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">Page</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('core', 'div-simple')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">DivSimple</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('core', 'paragraph')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">Paragraph</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('core', 'table')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">Table</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('core', 'form')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">Form</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('core', 'input-text-type')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">InputTextType</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('core', 'feature')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">Feature</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('client')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JWebMP Client</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('client', 'ajax-call')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AjaxCall</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('client', 'ajax-response')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AjaxResponse</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('client', 'ipage-configurator')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">IPageConfigurator</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('client', 'ipage')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">IPage</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('client', 'site-call-intercepter')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">SiteCallIntercepter</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('client', 'ajax-call-intercepter')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AjaxCallIntercepter</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('client', 'data-call-intercepter')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">DataCallIntercepter</a>
				</wa-tree-item>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<span style="font-weight:var(--wa-font-weight-semibold);">Angular Generation</span>
			<wa-tree-item>
				<a (click)="navigateToPlugin('angular')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Angular Plugin</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular', 'ngapplication')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">NGApplication</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular', 'ng-if')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">NgIf</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular', 'ng-for')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">NgFor</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular', 'router-link')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">RouterLink</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular', 'router-outlet')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">RouterOutlet</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular', 'type-script-compiler')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">TypeScriptCompiler</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular', 'stomp-server')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">StompServer</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('angular-maven-plugin')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Angular Maven Plugin</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('typescript-client')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">TypeScript Client Annotations</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('angular-forms')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Angular Forms</a>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<span style="font-weight:var(--wa-font-weight-semibold);">Data & Grids</span>
			<wa-tree-item>
				<a (click)="navigateToPlugin('aggrid')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">AG Grid</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('aggrid', 'ag-grid')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgGrid</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('aggrid', 'ag-grid-column-def')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgGridColumnDef</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('aggrid', 'ag-grid-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgGridOptions</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('aggrid-enterprise')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">AG Grid Enterprise</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('aggrid-enterprise', 'ag-grid-enterprise-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgGridEnterpriseOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('aggrid-enterprise', 'ag-grid-enterprise-column-def')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgGridEnterpriseColumnDef</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('datatables')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">DataTables</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('datatables', 'data-table')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">DataTable</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('datatables', 'data-table-page-configurator')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">DataTablePageConfigurator</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('datatables', 'data-table-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">DataTableOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('datatables', 'data-table-column-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">DataTableColumnOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('datatables', 'data-tables-responsive-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">DataTablesResponsiveOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('datatables', 'data-tables-buttons-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">DataTablesButtonsOptions</a>
				</wa-tree-item>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<span style="font-weight:var(--wa-font-weight-semibold);">Charts & Visualisation</span>
			<wa-tree-item>
				<a (click)="navigateToPlugin('agcharts')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">AG Charts</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts', 'ag-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts', 'ag-bar-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgBarChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts', 'ag-line-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgLineChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts', 'ag-pie-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgPieChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts', 'ag-donut-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgDonutChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts', 'ag-area-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgAreaChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts', 'ag-scatter-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgScatterChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts', 'ag-bubble-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgBubbleChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts', 'ag-combination-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgCombinationChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts', 'ag-chart-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgChartOptions</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('agcharts-enterprise')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">AG Charts Enterprise</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-candlestick-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgCandlestickSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-waterfall-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgWaterfallSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-treemap-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgTreemapSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-sunburst-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgSunburstSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-sankey-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgSankeySeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-range-bar-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgRangeBarSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-range-area-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgRangeAreaSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-radial-column-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgRadialColumnSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-radial-bar-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgRadialBarSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-radar-line-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgRadarLineSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-radar-area-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgRadarAreaSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-nightingale-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgNightingaleSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-histogram-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgHistogramSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-heatmap-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgHeatmapSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-funnel-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgFunnelSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-chord-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgChordSeriesOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('agcharts-enterprise', 'ag-ohlc-series-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">AgOhlcSeriesOptions</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('chartjs')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Chart.js</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('chartjs', 'bar-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">BarChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('chartjs', 'line-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">LineChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('chartjs', 'pie-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">PieChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('chartjs', 'doughnut-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">DoughnutChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('chartjs', 'radar-chart')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">RadarChart</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('c3')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">C3.js</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('d3')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">D3.js</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('jqplot')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">jqPlot</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('easy-pie-chart')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Easy Pie Chart</a>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<span style="font-weight:var(--wa-font-weight-semibold);">Scheduling</span>
			<wa-tree-item>
				<a (click)="navigateToPlugin('fullcalendar')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">FullCalendar</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('fullcalendar', 'full-calendar')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FullCalendar</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fullcalendar', 'full-calendar-options')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FullCalendarOptions</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fullcalendar', 'full-calendar-event')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FullCalendarEvent</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('fullcalendar-pro')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">FullCalendar Pro</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('fullcalendar-pro', 'full-calendar-pro')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FullCalendarPro</a>
				</wa-tree-item>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<span style="font-weight:var(--wa-font-weight-semibold);">Icons</span>
			<wa-tree-item>
				<a (click)="navigateToPlugin('fontawesome')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Font Awesome</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome', 'font-awesome')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesome</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome', 'font-awesome-layers')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesomeLayers</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome', 'font-awesome-layer-counter')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesomeLayerCounter</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome', 'font-awesome-layer-text')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesomeLayerText</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome', 'font-awesome-list')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesomeList</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome', 'font-awesome-icons')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesomeIcons</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome', 'font-awesome-brand-icons')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesomeBrandIcons</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome', 'font-awesome-styles')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesomeStyles</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome', 'font-awesome-sizes')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesomeSizes</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome', 'font-awesome-transforms')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesomeTransforms</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('fontawesome-pro')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Font Awesome Pro</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome-pro', 'font-awesome-duotone')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesomeDuotone</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome-pro', 'font-awesome5pro-styles')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesome5ProStyles</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome-pro', 'font-awesome5families')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesome5Families</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome-pro', 'icon-family')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">IconFamily</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome-pro', 'font-awesome5pro-icons')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesome5ProIcons</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('fontawesome-pro', 'font-awesome5pro-page-configurator')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">FontAwesome5ProPageConfigurator</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('themify-icons')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Themify Icons</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('themify-icons', 'themify-icon')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">ThemifyIcon</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('themify-icons', 'themify-icons')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">ThemifyIcons</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('themify-icons', 'themify-icons-page-configurator')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">ThemifyIconsPageConfigurator</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('material-icons')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Material Icons (MDI)</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('material-icons', 'mdiicon')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">MDIIcon</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('material-icons', 'mdiicons')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">MDIIcons</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('material-icons', 'material-icons-page-configurator')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">MaterialIconsPageConfigurator</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('material-design-icons')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Material Design Icons (Google)</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('material-design-icons', 'material-design-icon')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">MaterialDesignIcon</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('material-design-icons', 'material-design-icons')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">MaterialDesignIcons</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('material-design-icons', 'material-design-icon-themes')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">MaterialDesignIconThemes</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('material-design-icons', 'material-design-icon-size')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">MaterialDesignIconSize</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('material-design-icons', 'material-design-icon-colours')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">MaterialDesignIconColours</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('material-design-icons', 'material-design-icons-page-configurator')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">MaterialDesignIconsPageConfigurator</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('weather-icons')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Weather Icons</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('weather-icons', 'weather-icons')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">WeatherIcons</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('weather-icons', 'weather-icon')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">WeatherIcon</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('weather-icons', 'weather-icons-page-configurator')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">WeatherIconsPageConfigurator</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('glyphicons')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Glyphicons</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('glyphicons', 'glyphicon')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">Glyphicon</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('glyphicons', 'glyphicons')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">Glyphicons</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('glyphicons', 'glyphicons-page-configurator')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">GlyphiconsPageConfigurator</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('skycons')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Skycons</a>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<span style="font-weight:var(--wa-font-weight-semibold);">Animation</span>
			<wa-tree-item>
				<a (click)="navigateToPlugin('easing')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Easing Effects</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('easing', 'jqeasing-effects')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">JQEasingEffects</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('easing', 'jqeasing-page-configurator')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">JQEasingPageConfigurator</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('waves')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Waves Effect</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('waves', 'waves-effect-page-configurator')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">WavesEffectPageConfigurator</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('waves', 'waves-effects')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">WavesEffects</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('waves', 'waves-attach-feature')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">WavesAttachFeature</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('waves', 'waves-apply-to-selector-feature')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">WavesApplyToSelectorFeature</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('waves', 'waves-effects-inclusion-module')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">WavesEffectsInclusionModule</a>
				</wa-tree-item>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<span style="font-weight:var(--wa-font-weight-semibold);">Libraries</span>
			<wa-tree-item>
				<a (click)="navigateToPlugin('jquery')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">jQuery</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery', 'jquery-page-configurator')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">JQueryPageConfigurator</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery', 'jquery-inclusion-module')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">JQueryInclusionModule</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('globalize')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Globalize</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('globalize', 'globalize-page-configurator')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">GlobalizePageConfigurator</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('globalize', 'globalize-cultures')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">GlobalizeCultures</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('globalize', 'globalize-module-inclusions')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">GlobalizeModuleInclusions</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('prettify')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Google Code Prettify</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('waypoints')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">jQuery WayPoints</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('plus-as-tab')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Plus As Tab</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('prism')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">PrismJS</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('ngx-markdown')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">NGX Markdown</a>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<span style="font-weight:var(--wa-font-weight-semibold);">Real-Time Messaging</span>
			<wa-tree-item>
				<a (click)="navigateToPlugin('rabbitmq')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">RabbitMQ Comms</a>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<span style="font-weight:var(--wa-font-weight-semibold);">Runtime & Server</span>
			<wa-tree-item>
				<a (click)="navigateToPlugin('vertx')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JWebMP Vert.x</a>
				<wa-tree-item>
					<a (click)="navigateToComponent('vertx', 'jweb-mpvertx-servlet')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">JWebMPVertxServlet</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('vertx', 'jweb-mpajax-servlet')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">JWebMPAjaxServlet</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('vertx', 'jweb-mpdata-servlet')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">JWebMPDataServlet</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('vertx', 'jweb-mpcssservlet')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">JWebMPCSSServlet</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('vertx', 'jweb-mpscript-servlet')" href="javascript:void(0)" style="color:var(--wa-color-text-quiet);cursor:pointer;font-size:var(--wa-font-size-2xs);">JWebMPScriptServlet</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('localstorage')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Local Storage Security</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToPlugin('sessionstorage')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Session Storage Security</a>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<span style="font-weight:var(--wa-font-weight-semibold);">Notifications</span>
			<wa-tree-item>
				<a (click)="navigateToPlugin('toastr')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">Toastr</a>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<span style="color:var(--wa-color-brand-normal);font-weight:var(--wa-font-weight-semibold);">UI Frameworks</span>
			<wa-tree-item>
				<a (click)="navigateToFramework('web-awesome')" href="javascript:void(0)" style="color:var(--wa-color-brand-normal);cursor:pointer;font-size:var(--wa-font-size-xs);">WebAwesome</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToFramework('web-awesome-pro')" href="javascript:void(0)" style="color:var(--wa-color-brand-normal);cursor:pointer;font-size:var(--wa-font-size-xs);">WebAwesome Pro</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToFramework('bootstrap')" href="javascript:void(0)" style="color:var(--wa-color-brand-normal);cursor:pointer;font-size:var(--wa-font-size-xs);">Bootstrap</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToFramework('angular-material')" href="javascript:void(0)" style="color:var(--wa-color-brand-normal);cursor:pointer;font-size:var(--wa-font-size-xs);">Angular Material</a>
			</wa-tree-item>
			<wa-tree-item>
				<a (click)="navigateToFramework('jquery-ui')" href="javascript:void(0)" style="color:var(--wa-color-brand-normal);cursor:pointer;font-size:var(--wa-font-size-xs);">jQuery UI</a>
			</wa-tree-item>
		</wa-tree-item>
	</wa-tree>
</aside>